module.exports = __webpack_public_path__ + "static/img/appointment_code.2df1ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appointment_code.png
// module id = pOsq
// module chunks = 15